import { render, staticRenderFns } from "./DcsTable.vue?vue&type=template&id=b625c49a"
import script from "./DcsTable.vue?vue&type=script&lang=ts"
export * from "./DcsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports